import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urljoin from "url-join";

export const createOrderNotRefUrl = "/not-ref-contract";
export const changeOrderNotRefUrl = "/orders/not-ref-change-order";

export enum NotRefOrderSortField {
  itemNo = "itemNo"
}

export enum PreviewOrderSortField {
  ITEM_NO = "ITEM_NO"
}

export interface NotRefOrderUrlAdditional {
  type?: "submitted" | "timeout";
}

export type PreviewOrderSort = Sort<PreviewOrderSortField>;

export type NotRefOrderUrlSort = Sort<NotRefOrderSortField>;
export type NotRefOrderQueryParams = Pagination &
  NotRefOrderUrlSort &
  NotRefOrderUrlAdditional;
export type PreviewOrderNotRefQueryParam = Pagination & PreviewOrderSort;

export const previewOrderUrl = `${createOrderNotRefUrl}/preview-order`;
export const previewChangeOrderUrl = `${changeOrderNotRefUrl}/preview-order`;

export const previewOrderNotRefPath = (id: string) =>
  urljoin(previewOrderUrl, id);
export const previewOrderListNotRefUrl = (
  id,
  params?: PreviewOrderNotRefQueryParam
) => previewOrderNotRefPath(id) + "?" + stringifyQs(params);

export const previewChangeOrderNotRefPath = (id: string) =>
  urljoin(previewChangeOrderUrl, id);
export const previewChangeOrderListNotRefUrl = (
  id,
  params?: PreviewOrderNotRefQueryParam
) => previewChangeOrderNotRefPath(id) + "?" + stringifyQs(params);

export const notRefOrderPath = () =>
  createOrderNotRefUrl + "?" + stringifyQs({ enabledCreate: "true" });

export const notRefOrderUrl = (params?: any) =>
  notRefOrderPath() + "&" + stringifyQs(params);

export const getNotRefCreateOrderPath = (id: string) =>
  !!id
    ? urljoin(createOrderNotRefUrl, encodeURIComponent(id))
    : createOrderNotRefUrl;

export const getNotRefChangeOrderPath = (id: string) =>
  !!id
    ? urljoin(changeOrderNotRefUrl, encodeURIComponent(id))
    : changeOrderNotRefUrl;

export const getNotRefPreviewOrderPath = (id: string) =>
  !!id ? urljoin(previewOrderUrl, encodeURIComponent(id)) : previewOrderUrl;
export const getNotRefPreviewChangeOrderPath = (id: string) =>
  !!id
    ? urljoin(previewChangeOrderUrl, encodeURIComponent(id))
    : previewChangeOrderUrl;

export const getNotRefCreateOrderUrl = (id: string) => (
  params?: NotRefOrderQueryParams
): string => {
  if (params === undefined) {
    return getNotRefCreateOrderPath(id);
  } else {
    return getNotRefCreateOrderPath(id) + "?" + stringifyQs(params);
  }
};

export const getNotRefPreviewOrderUrl = (id: string) => (
  params?: NotRefOrderQueryParams
): string => {
  if (params === undefined) {
    return getNotRefPreviewOrderPath(id);
  } else {
    return getNotRefPreviewOrderPath(id) + "?" + stringifyQs(params);
  }
};

export const getNotRefPreviewChangeOrderUrl = (id: string) => (
  params?: NotRefOrderQueryParams
): string => {
  if (params === undefined) {
    return getNotRefPreviewChangeOrderPath(id);
  } else {
    return getNotRefPreviewChangeOrderPath(id) + "?" + stringifyQs(params);
  }
};

export const getNotRefChangeOrderUrl = (id: string) => (
  params?: NotRefOrderQueryParams
): string => {
  if (params === undefined) {
    return getNotRefChangeOrderPath(id);
  } else {
    return getNotRefChangeOrderPath(id) + "?" + stringifyQs(params);
  }
};
